import { render, staticRenderFns } from "./FormGen.vue?vue&type=template&id=c523f62e"
import script from "./FormGen.vue?vue&type=script&lang=js"
export * from "./FormGen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports